import Component from '../colorz/Component';

import device   from '../colorz/utils/device';
import emitter  from '../colorz/utils/Emitter';
import Easing  from '../colorz/utils/Easing';

module.exports = class Collapse extends Component {
  onInit( el, args) {
    // Initializations
    this.onOpen     = this.onOpen.bind( this );
    this.onClose    = this.onClose.bind( this );
    this.otherOpen  = this.otherOpen.bind( this );
    this.onToggle   = this.onToggle.bind( this );
    this.onOpenNext = this.onOpenNext.bind( this );

    this.el         = el;
    this.parent     = args.parent;
    this.content    = this.el.querySelector('.js-content');
    this.title      = this.el.querySelector('.js-title');

    this.easing     = null;
    this.isOpen     = false;

    this.timer      = null;
  }


  onReady() {
    // si aucun contenu return
    if( this.content == void 0 || this.title == void 0 ) { return; }

    // attache l'event à l'élément
    this.title.addEventListener( device.pointerdown, this.onToggle );

    // déclare l'évènement collapse:open
    emitter.on('collapse:open', this.otherOpen);

    this.onResize();
  }


  onResize() {
    // hauteur du wrapper
    this.wrapperContentHeight = this.content.firstElementChild.offsetHeight;

    // si ouvert prend la taille du wrapper sinon 0
    if( this.isOpen ) {
      this.content.style.height = this.wrapperContentHeight + 'px';
    }
    else {
      this.content.style.height = 0 + 'px';
    }
  }


  onToggle() {
    if( this.isOpen ) {
      this.onClose();
    }
    else {
      this.onOpen();
    }
  }


  onOpen() {
    // animation
    this.easing = new Easing({
      type: 'easeInOutQuart',
      duration: 500,
      start: 0,
      end: this.wrapperContentHeight,
      callback: ()=>{ this.easing = null; }
    });

    // initialise l'anim
    this.easing.isActive = true;
    this.isOpen = true;
    this.el.querySelector('.index').classList.add('is-open');

    // déclenche l'évènement collapse:open
    emitter.emit('collapse:open', {el: this.el, parent: this.parent});

    this.timer = setTimeout( this.onOpenNext, 5300)
  }

  onOpenNext() {
    var isNext = false;

    for( let i = 0 ; i < window.collapsesItem.length ; i++ ) {
      if( isNext ) {
        window.collapsesItem[i].onOpen();
        break;
      }
      if( window.collapsesItem[i] == this ) {
        isNext = true;
      }

      if( i == window.collapsesItem.length - 1 ) {
        window.collapsesItem[0].onOpen();
      }
    }
  }

  onUpdate() {
    if( this.easing != null ) {
      this.content.style.height = this.easing.value + 'px';
    } 
  }


  otherOpen( args ) {
    // check parent + autres éléments pour l'ouverture
    if( this.el == args.el || this.parent != args.parent || !this.isOpen ) { return; }
    this.onClose();
  }


  onClose() {
    // reverse de l'anim onOpen
    this.easing = new Easing({
      type: 'easeInOutQuart',
      duration: 500,
      start: this.wrapperContentHeight,
      end: 0,
      callback: ()=>{ this.easing = null; }
    });

    this.el.querySelector('.index').classList.remove('is-open');

    this.el.classList.add('is-remove');
    clearTimeout( this.timer );

    // initialise l'anim
    this.easing.isActive = true;
    this.isOpen = false;
  }
}